import { useCallback } from "react";
import { useFormatReportSection } from "~/api/custom-reports/custom-reports";
import { trackEvent } from "~/utils/analytics";

export const useFormatSection = (
  organizationId: string,
  projectId: string,
  reportId: string,
  sectionId: string
) => {
  const { mutateAsync, isPending: isFormatting } = useFormatReportSection();

  const formatSection = useCallback(
    async (content: string, instructions: string): Promise<string | null> => {
      if (!sectionId || !content) return null;

      try {
        const response = await mutateAsync({
          organizationId,
          projectId,
          reportId,
          reportSectionId: sectionId,
          data: { content, instructions },
        });

        trackEvent({
          eventName: "app/report/section_format.success",
          properties: {
            sectionId,
            instructionsLength: instructions.length,
            hasCustomInstructions: instructions !== "Tidy up",
          },
        });

        return response.formattedContent;
      } catch (error) {
        trackEvent({
          eventName: "app/report/section_format.error",
          properties: {
            sectionId,
            error: error instanceof Error ? error.message : "Unknown error",
          },
        });
        throw error;
      }
    },
    [mutateAsync, organizationId, projectId, reportId, sectionId]
  );

  return { formatSection, isFormatting };
};
